import {useState} from 'react';
import { FIREBASE_AUTH } from '../../../FirebaseConfig';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from "react-router-dom";
import InputField from '../InputField';
import '../Authentication.css';

function Register() {
    const [theEmail, setTheEmail]= useState('');
    const [thePassword, setThePassword] = useState('');
    const [theConfPassword, setTheConfPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const auth = FIREBASE_AUTH
    const nav = useNavigate()

    const signUp = async (e) => {
        e.preventDefault();
        setLoading(true)
        if (thePassword.localeCompare(theConfPassword) === 0) {
            try {
                const response = await createUserWithEmailAndPassword(auth,theEmail,thePassword)
                nav('/')
            } catch (error) {
                alert("Registration failed " + error.message)
            } finally {
                setLoading(false)
            }
        } else {
            alert("Your passwords do not match")
            setLoading(false)
        }
    }

    return (
        <div className='auth-main-container'>
            <div className='auth-white-box'>
                <form className='auth-form' onSubmit={signUp}>
                    <h1>REGISTER</h1>

                    <InputField
                        label="EMAIL"
                        name="email"
                        value={theEmail}
                        type="email"
                        placeholder="fakeEmail@gatech.edu"
                        onChange={setTheEmail}
                    />

                    <InputField
                        label="PASSWORD"
                        name="password"
                        value={thePassword}
                        type="password"
                        placeholder="Password"
                        onChange={setThePassword}
                    />

                    <InputField
                        label="CONFIRM PASSWORD"
                        name="confirmPassword"
                        value={theConfPassword}
                        type="password"
                        placeholder="Re-type Password"
                        onChange={setTheConfPassword}
                    />

                    <input
                        className="auth-button"
                        type="submit"
                        value="FINISH"
                        disabled={loading}
                    />
                </form>
            </div>
        </div>
    )
}

export default Register